import React from "react";
import styles from "./styles.module.scss";

interface ChromeBrowserSectionProps {
  onDownloadClick: () => void;
}

/**
 * Chrome浏览器部分组件
 * 显示浏览器介绍和获取早期访问按钮
 */
const ChromeBrowserSection = ({ onDownloadClick }: ChromeBrowserSectionProps) => {
  return (
    <div className={styles.chromeBrowserSection}>
      <div className={styles.content}>
        <div className={styles.title}>
          The W<span>🌎</span>rld&apos;s First
        </div>
        <div className={styles.title}>Agentic Browser</div>
        <p className={styles.subtitle}>Go beyond browsing with Fellou AI Browser that takes automated web action</p>
        {/* 添加Get Early Access按钮 */}
        <button className={styles.earlyAccessButton} onClick={onDownloadClick}>
          <img
            src="https://fellou.s3.us-west-1.amazonaws.com/images/20250913-155226.png"
            alt="Download Icon"
            className={styles.downloadIcon}
          />
          <span className={styles.buttonText}>Get Early Access</span>
        </button>
      </div>
    </div>
  );
};

export default ChromeBrowserSection;
